export enum EAppColors {
  /** The background variables must match what's being set in color-scale.css */
  backgroundDarkMode = 'var(--gray-1000)',
  backgroundLightMode = 'var(--gray-1200)',
}
